/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface PasswordChangeRequest {
  /** @minLength 1 */
  current_password: string;
  /**
     * @minLength 8
     * @maxLength 128
     */
  new_password: string;
  logout_all_devices?: boolean;
}
